import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private _authenticated: boolean = false;
    private _httpClient = inject(HttpClient);
    private _userService = inject(UserService);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string {
        return localStorage.getItem('accessToken') ?? '';
    }

    set refreshToken(token: string) {
        localStorage.setItem('refreshToken', token);        
    }

    get refreshToken(): string {
        return localStorage.getItem('refreshToken') ?? '';
    }

    set lastApplicationId(applicationId: string) {
        localStorage.setItem('lastApplicationId', applicationId);
    }

    get lastApplicationId(): string {
        return localStorage.getItem('lastApplicationId') ?? '';
    }

    get isTokenCloseToExpire(): boolean {
        const token = this.accessToken;
        const tokenPayload = JSON.parse(atob(token.split('.')[1]));
        const expirationDate = new Date(tokenPayload.exp * 1000);
        const now = new Date();
        const timeDifference = expirationDate.getTime() - now.getTime();
        const timeDifferenceInSeconds = timeDifference / 1000;        
        return timeDifferenceInSeconds < 180;
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {
        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');

        localStorage.removeItem('refreshToken');

        localStorage.removeItem('user');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        // Check the access token availability
        if (!this.accessToken) {
            return of(false);
        }

        return of(true);
    }

    checkAdmin(): Observable<boolean> {
        return this.check().pipe(
            switchMap((authenticated) => {
                if (!authenticated) {
                    return of(false);
                }

                return of(AuthUtils.hasAdminRole(this.accessToken));
            })
        );
    }
}
